import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { RiskCategory } from 'src/app/commons/models/risk-category.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as RiskCategoryActions from 'src/app/store/actions/risk-category.actions';
import { AppState } from 'src/app/store/reducers';
import * as RiskCategorySelectors from 'src/app/store/selectors/risk-category.selectors';
import * as AuthSelectors from 'src/app/store/selectors/auth.selectors';

import { RiskCategoryFilters } from './../../../commons/models/risk-category.model';
import { RiskCategorysColumn } from '../risk-category-list/risk-category-list.component';



@Component({
  selector: 'app-risk-category-selection',
  templateUrl: './risk-category-selection.component.html',
  styleUrls: ['./risk-category-selection.component.scss']
})
export class RiskCategorySelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  riskCategories: Observable<RiskCategory[]>;
  filters: Observable<RiskCategoryFilters>;

  @Input()
  defaultFilters: RiskCategoryFilters = {
    search: "",
  }

  displayedColumns: RiskCategorysColumn[] = ["id", "name", "actions"];

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;
  constructor(private store$: Store<AppState>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.riskCategories = this.store$.pipe(select(RiskCategorySelectors.getRiskCategorys), takeUntil(this.unsubscribe$), map(dtos => dtos ? dtos.map(dto => new RiskCategory(dto)) : null));
    this.total = this.store$.pipe(select(RiskCategorySelectors.getTotalRiskCategorys), takeUntil(this.unsubscribe$));
    this.filters = this.store$.pipe(select(RiskCategorySelectors.getFilters), takeUntil(this.unsubscribe$));
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(RiskCategoryActions.loadRiskCategories(
      { page: 1, perPage: this.pageSizeOptions[0], filters: this.defaultFilters }));
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(RiskCategoryActions.changeSort({ order: sort.active, direction: sort.direction }));
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(RiskCategoryActions.changePage({ page: pageEvent.pageIndex + 1, size: pageEvent.pageSize }))
  }

  filtersChange(filters: RiskCategoryFilters) {
    this.store$.dispatch(RiskCategoryActions.changeFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectRiskCategory(riskCategory: RiskCategory) {
    if (riskCategory) {
      this.store$.dispatch(RiskCategoryActions.riskCategorySelected({ riskCategory: riskCategory.toDTO() }));
    }
  }

  close() {
    this.store$.dispatch(RiskCategoryActions.closeSelectionDialog())
  }
}
